import createSvgIcon from "./utils/create_icon"

const CheckmarkSmall = createSvgIcon(<path clipRule="evenodd" d="M15.707 9.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 12.586l3.293-3.293a1 1 0 0 1 1.414 0z" fill="currentColor" fillRule="evenodd" />, "CheckmarkSmall")
export default CheckmarkSmall
